const SvgAutomation2 = (props) => (
  <>
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="m72.37 184.07 34.46 34.3M117.98 218.62l34.39-34.55M152.37 184.07l40-40.18-80.18-79.82-79.82 80.18 40 39.82M117.47 298.39l34.29-34.46"
    />
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="m72.58 183.73-40 40.18 40 39.82M107.2 298.19l-34.62-34.46M117.93 149.79l34.44 34.28M152.37 184.07l40 39.82-40.5 39.9M106.68 149.47l-34.1 34.26M117.98 229.83l34.39 34.24M106.7 229.59l-34.33 34.48M152.37 264.07l40 39.82-79.82 80.18-80.18-79.82 40-40.18"
    />
    <circle cx={112.37} cy={143.96} r={8} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={112.37} cy={224.06} r={8} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={112.37} cy={304.15} r={8} fill="none" stroke={props.p50} strokeMiterlimit={10} />
  </>
);

export default SvgAutomation2;
